import _ from "lodash";
import type { IScope } from "reducers/scope";
import { IProduct } from "records/item/item";
import { ISwatch, SwatchType } from "constants/color-swatches";
import theme from "styles/theme";
import Color from "color";
import siteConfig from "site-config";

export const getSwatchValue = (item: IProduct, scope: Pick<IScope, "brand">): string =>
    item?.[scope?.brand?.hasPreference?.("color_swatch_maps_to")] || item?.color || item?.__color;

export const getSwatch = (item: IProduct, scope: Pick<IScope, "brand">): ISwatch =>
    _.find(scope?.brand?.modules?.base?.color_swatches, { color: getSwatchValue(item, scope) });

export function getValidSwatch(item: IProduct, scope: Pick<IScope, "brand">): ISwatch {
    const swatch = getSwatch(item, scope);
    return swatch?.swatch_type !== "hex" || isValidHexColor(swatch?.value) ? swatch : null;
}

export const getSwatchLabel = (item: IProduct, scope: Pick<IScope, "brand">): string =>
    item?.[scope?.brand?.hasPreference?.("color_swatch_label")] || item?.color || item?.__color;

export const getBaseSwatchStyles = (swatch: ISwatch) => {
    switch (swatch?.swatch_type) {
        case SwatchType.HEX:
            return {
                backgroundImage: "none",
                backgroundColor: `#${swatch.value}`,
                border:
                    isValidHexColor(swatch.value) && isContrastRequired(`#${swatch.value}`)
                        ? `1px solid ${theme.palette.lightGrey}`
                        : "none",
            };
        case SwatchType.FILE:
            return {
                backgroundImage: `url(//cdn1.nuorder.com/brand_color_swatch/${swatch.value}.jpg)`,
                backgroundSize: "contain",
                backgroundPosition: "center",
            };
        default:
            return null;
    }
};

const isValidHexColor = (value: string): boolean => /^([0-9a-fA-F]{3}){1,2}$/.test(value);
const isContrastRequired = (hexColor = "white") => Color(hexColor).contrast(Color("white")) < 1.1;

export const displayingNewColorways = (activeBrand) => {
    return (
        siteConfig.NEW_COLORWAY_ENABLED === "true" &&
        activeBrand.hasPreference("new_colorway") &&
        activeBrand.hasPreference("group_products")
    );
};
